import { render } from "./audio-field.vue?vue&type=template&id=f8dc11a6"
import script from "./audio-field.vue?vue&type=script&lang=js"
export * from "./audio-field.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./audio-field.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__